export default {
    entityKey: 'users',
    titles: {
        singular: 'User',
        plural: 'Users'
    }
}